module.exports = __webpack_public_path__ + "static/media/maxSuccessionLosses_40_50.a6b9cb82.png";